import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAssignProjectToPortfolioRequestFailure(project, portfolio) {
      const req = getState().find(
        (req) =>
          req.project.uuid === project.uuid &&
          req.portfolio.uuid === portfolio.uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isAssignProjectToPortfolioRequestPending(project, portfolio) {
      const req = getState().find(
        (req) =>
          req.project.uuid === project.uuid &&
          req.portfolio.uuid === portfolio.uuid,
      );

      return req ? req.request.isPending : false;
    },
    isAssignProjectToPortfolioRequestSuccess(project, portfolio) {
      const req = getState().find(
        (req) =>
          req.project.uuid === project.uuid &&
          req.portfolio.uuid === portfolio.uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
